import { Col, Row } from 'antd';
import DefaultLayout from '../components/DefaultLayout';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';



function About() {
    return (
        <DefaultLayout>
            <Row className='p-5' justify='center' gutter={24}>
                <Col lg={24} sm={24} xs={24}>

                    <div className='row'>
                        <div className='fleet-img'>
                            <h1><span>Smart Cars</span></h1>
                        </div>

                        <div className='col-md-6 mt-3'>
                            <h2>About Smart Cars</h2>
                            <p>Smart Cars Kenya is one of the leading car hire companies in Nairobi. We are based at the CBD area, Nairobi. We have a great selection of rental cars ranging from small city cars to sedans/ saloon cars, to 4X4s all in the latest models.</p>

                            <p>Smart Cars-Ke is a trading name of Booking.com Transport Limited which is a limited company registered in Kenya (Number: 05179829) whose registered address is at 00100 Central Business District, Nairobi, EC4V 6JA. VAT number: KE 855349007.</p>

                            <p>Smart Cars-Ke is part of Kennya Booking Holdings Limited companies, and is among the top countrywide leading in online travel, cargo transportation & related services.</p>

                            <p>We also offer corporate cars for hire at very competitive prices. We are your one-stop car hire company in Nairobi. Whether you are looking for a small car to move around in for a few days or a sedan or even a 4X4 for a great adventure in the wild, we have you covered.</p>

                            <p> <span><i>Here is a pro-tip, you can always get a 20% discount simply by booking your rental car directly on our website.</i></span></p>
                        </div>

                        <div className='col-md-6 mt-3'>
                            <h3>Conclusion</h3>  
                            <p>In conclusion, finding a car hire company in Nairobi shouldn’t cause you a headache anymore. Simply consider Samart Cars since we offer quality car hire services within and outside Nairobi, as we will help you decide on the car that best suits your needs and you are set.</p>

                            <p>Finally, whether you are a car enthusiast who enjoys a new set of wheels often, or you don’t need to drive as much anymore, or you need a sweet ride to impress some potential business partners or something in between, you have this comprehensive service from Smart Cars, and we are here to make sure you choose the best car for hire in Nairobi and all our outlets every time.</p>
                        </div>
                    </div>
                </Col>
                <Col lg={10} sm={24} xs={24} className="text-right p-3 mt-5">
                    <div>
                        <button className="btn1" style={{backgroundColor: 'orangered', color: 'white'}}>
                            <Link className='book' to='/'>
                                <FontAwesomeIcon icon={faAngleLeft} size="3x" className='m-0' style={{color: 'orangered'}}/>Back
                            </Link>
                        </button>
                    </div>
                </Col> 
            </Row>
        </DefaultLayout>
    );
}

export default About;